import { useEffect, useState } from "react";
import useRefreshToken from "../hooks/useRefreshToken";
import useAuth from "../hooks/useAuth";
import { Outlet } from "react-router-dom";

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, persist } = useAuth();

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                // Tenta il refresh solo se persist è true e non abbiamo un token
                if (persist && !auth?.accessToken) {
                    await refresh();
                }
            } catch (err) {
                console.error('Error refreshing token on mount:', err);
            } finally {
                if (isMounted) {
                    setIsLoading(false);
                }
            }
        };

        // Se abbiamo già un token o persist è false, non fare loading
        if (auth?.accessToken || !persist) {
            setIsLoading(false);
        } else {
            verifyRefreshToken();
        }

        return () => {
            isMounted = false;
        };
    }, [auth?.accessToken, persist, refresh]);

    return (
        <>
            {isLoading ? <p>Loading...</p> : <Outlet />}
        </>
    );
};

export default PersistLogin;